module.exports = __webpack_public_path__ + "img/bg_product_bianjie1@2x.1fb69c36.png";